export default __webpack_public_path__ + "static/media/lastmile.402e17bf.svg";